import {Icon, Typography} from '@bonprix/design-system';
import {ActiveUnderlineWrapper} from './ActiveUnderlineWrapper.jsx';
import Device from '@core/scripts/components/device';
import Landmark from '@core/scripts/components/landmark-adapter';
import {useRef} from 'react';

export default function SecondLevelItem({
    navigationItem,
    setCurrentHoveredItemId,
    currentHoveredItemId,
    thirdLevelEmpty = false,
}) {
    const isTouchDevice = useRef(Device.isTouch() || matchMedia('(hover: none)').matches);
    const isActive = (!currentHoveredItemId && navigationItem.active) || currentHoveredItemId === navigationItem.id;
    const titleColor = navigationItem.fontColor || "primary";

    function updateHoveredItem() {
        setCurrentHoveredItemId(navigationItem.id);
    }

    const handlePointerEnter = () => {
        if (!isTouchDevice.current) {
            updateHoveredItem();
        }
    };

    const handleOnClick = (e) => {
        if (isTouchDevice.current && !isActive) {
            e.preventDefault();
            updateHoveredItem();
            return;
        }
        const naviLmValue = `hn\\${navigationItem.id}\\\\`;
        Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
    };

    return (
        <div
            onPointerEnter={handlePointerEnter}
            className={`navigation__item -level:second ${isActive ? 'is-hovered' : ''}`}
        >
            <a href={navigationItem.url} className={'navigation__item-label'} onClick={handleOnClick}>
                <ActiveUnderlineWrapper
                    navigationItem={navigationItem}
                    currentHoveredItemId={currentHoveredItemId}
                    isShopActive={true}
                >
                    <Typography color={titleColor} variant="bonprix-h6" component={'span'}>
                        {navigationItem.title}
                    </Typography>
                </ActiveUnderlineWrapper>
            </a>
            {isActive && !thirdLevelEmpty && <Icon variant={'back'} className="navigation__next-btn" />}
        </div>
    );
}
